
import React, { useRef, useEffect } from "react";
import { Card, CardContent } from "@/components/ui/card";

interface IframePageContent {
  url: string;
  refreshInterval: number; // in seconds
}

interface IframePageProps {
  content: IframePageContent;
}

const IframePage: React.FC<IframePageProps> = ({ content }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { url, refreshInterval } = content;

  useEffect(() => {
    // Set up auto-refresh for the iframe
    const refreshTimer = setInterval(() => {
      if (iframeRef.current) {
        iframeRef.current.src = iframeRef.current.src;
      }
    }, refreshInterval * 1000);

    return () => clearInterval(refreshTimer);
  }, [refreshInterval]);

  return (
    <div className="flex justify-center w-full">
      <Card className="w-full max-w-4xl overflow-hidden">
        <CardContent className="p-4">
          <div className="relative pb-4">
            {/* Fallback error message will be shown if iframe fails to load */}
            <iframe
              id="calendar-iframe"
              ref={iframeRef}
              src={url}
              className="w-full min-h-[60vh] border-0"
              onError={() => {
                if (iframeRef.current) {
                  iframeRef.current.style.display = 'none';
                }
              }}
              title="External Content"
            />
            <div id="iframe-error" className="hidden absolute inset-0 flex items-center justify-center">
              <p className="text-xl text-red-500">הטענת הנתונים נכשלה, אנא נסה שוב.</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default IframePage;
